import { SET_UNIT_CONTEXT, CLEAR_UNIT_CONTEXT } from "../actions";

const initialState = {
  programId       : null,   // programme document ID
  unitName        : null,   // human‑readable name
  unitCode        : null,   // slug / legacy ID
  company         : null,
  collectionBrand : null,
  learnerUid      : null,
  userDisplayName : null,
  role            : "editor",   // "learner" | "editor"
};

const unitContextReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_UNIT_CONTEXT:
      return { ...state, ...action.payload };

    case CLEAR_UNIT_CONTEXT:
      return initialState;

    default:
      return state;
  }
};

export default unitContextReducer;
